import { render, staticRenderFns } from "./CapaLivro.vue?vue&type=template&id=780707a4&scoped=true"
import script from "./CapaLivro.vue?vue&type=script&setup=true&lang=ts"
export * from "./CapaLivro.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CapaLivro.vue?vue&type=style&index=0&id=780707a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780707a4",
  null
  
)

export default component.exports